import dayjs, { extend } from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

export function formatUpdateTime(timestamp: string) {
    if (timestamp === "Live") return "Live";
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.tz.setDefault("America/Chicago");
    const date = dayjs(timestamp);
    extend(advancedFormat);
    return date.format("MMM D, ha z");
}

export function formatPayPeriod(start: string) {
    dayjs.extend(utc);
    const startDate = dayjs.utc(start);
    //depending on the data we receive, we may calculate the pay period based on the start number plus some offset in the future.
    const endDate = startDate.endOf("month");
    return `${startDate.format("MMMM DD")} - ${endDate.format("MMMM DD")}`;
}
